import {
  SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY,
  DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY,
  HIDE_CAPACITY_DIALOG,
  DISPLAY_CAPACITY_DIALOG,
  DISPLAY_EVENTS_IN_DDL,
  SET_SQUAD_VISIBILITY
} from './constants';

export const setSquadCapacity = (id, value) => ({
  type: SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY,
  payload: {
    id,
    value
  }
});

export const displaySquads = data => ({
  type: DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY,
  payload: data
});

export const hideCapacityDialog = () => ({
  type: HIDE_CAPACITY_DIALOG
});

export const displayCapacityDialog = title => ({
  type: DISPLAY_CAPACITY_DIALOG,
  payload: title
});

export const displayEventsInDropDown = data => ({
  type: DISPLAY_EVENTS_IN_DDL,
  payload: data
});

export const setSquadVisibility = (id, value) => ({
  type: SET_SQUAD_VISIBILITY,
  payload: {
    id,
    value
  }
});



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/actionTypes.js